var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBz = function SvgIconBz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0-4.118-2.075-7.752-5.236-9.913L12 1.565l-6.763.522A11.99 11.99 0 0 0 0 12c0 4.119 2.075 7.752 5.237 9.913l6.763.522 6.764-.522A11.99 11.99 0 0 0 24 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#A2001D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.764 2.087A11.94 11.94 0 0 0 12.001 0C9.49 0 7.163.77 5.237 2.087zM5.236 21.913A11.94 11.94 0 0 0 12 24c2.509 0 4.837-.77 6.763-2.087z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 17.738A5.74 5.74 0 1 0 12 6.26a5.74 5.74 0 0 0 0 11.478"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 16.696a4.696 4.696 0 1 0 0-9.392 4.696 4.696 0 0 0 0 9.391"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 15.13a3.13 3.13 0 1 0 0-6.261 3.13 3.13 0 0 0 0 6.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 11.217 10.303 12v1.304l1.695 1.043 1.696-1.043V12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M13.695 10.436h-3.391V12h3.391z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconBz;